module.exports = __webpack_public_path__ + "img/38.ff8249d2.jpg";